import { TFunction } from 'i18next';

export const FIVE_MINUTES_IN_MS = 5 * 60 * 1000;
export const CACHE_BYPASS_DELAY_MS = 500;
export const TEN_MINUTES_IN_MS = 10 * 60 * 1000;
export const THIRTY_MINUTES_IN_MS = 30 * 60 * 1000;

export const DEFAULT_MAX_RANGE = 31;

export const DAYS_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const ISO_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d{3})?(?:Z|[+-]\d{2}:\d{2})?$/;

export const getWeekDaysOptions = (t: TFunction) => [
	{ label: t('days.monday'), value: 0 },
	{ label: t('days.tuesday'), value: 1 },
	{ label: t('days.wednesday'), value: 2 },
	{ label: t('days.thursday'), value: 3 },
	{ label: t('days.friday'), value: 4 },
	{ label: t('days.saturday'), value: 5 },
	{ label: t('days.sunday'), value: 6 },
];

export const thirtyOneDaysOptions = [
	{ label: '1', value: 1 },
	{ label: '2', value: 2 },
	{ label: '3', value: 3 },
	{ label: '4', value: 4 },
	{ label: '5', value: 5 },
	{ label: '6', value: 6 },
	{ label: '7', value: 7 },
	{ label: '8', value: 8 },
	{ label: '9', value: 9 },
	{ label: '10', value: 10 },
	{ label: '11', value: 11 },
	{ label: '12', value: 12 },
	{ label: '13', value: 13 },
	{ label: '14', value: 14 },
	{ label: '15', value: 15 },
	{ label: '16', value: 16 },
	{ label: '17', value: 17 },
	{ label: '18', value: 18 },
	{ label: '19', value: 19 },
	{ label: '20', value: 20 },
	{ label: '21', value: 21 },
	{ label: '22', value: 22 },
	{ label: '23', value: 23 },
	{ label: '24', value: 24 },
	{ label: '25', value: 25 },
	{ label: '26', value: 26 },
	{ label: '27', value: 27 },
	{ label: '28', value: 28 },
	{ label: '29', value: 29 },
	{ label: '30', value: 30 },
	{ label: '31', value: 31 },
];

export const getMonthOptions = (t: TFunction) => [
	{ label: t('months.january'), value: 1 },
	{ label: t('months.february'), value: 2 },
	{ label: t('months.march'), value: 3 },
	{ label: t('months.april'), value: 4 },
	{ label: t('months.may'), value: 5 },
	{ label: t('months.june'), value: 6 },
	{ label: t('months.july'), value: 7 },
	{ label: t('months.august'), value: 8 },
	{ label: t('months.september'), value: 9 },
	{ label: t('months.october'), value: 10 },
	{ label: t('months.november'), value: 11 },
	{ label: t('months.december'), value: 12 },
];
